import React, { useEffect, useState } from 'react';
import { API_FIELD_MAPPINGS, DATE_FORMAT } from 'utils/appConstants';
import { useDispatch, useSelector } from 'react-redux';
import {
  SubPanel,
  SubPanelRow,
  PanelRowDescriptor,
  PanelRowDisplay,
  PanelButtonRow,
  FullPanel,
  PanelContent
} from 'components/PanelComponents';
import { revertSidePanel } from 'reducers/sidePanel/actions';
import Text from 'components/Text';
import moment from 'moment';
import Panel from 'components/Panel';
import { BlueBorderButton } from 'components/Button';

const MeterPanel = ({ isActive }) => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.sidePanel.data);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  if (isActive && !isLoading) {
    return (
      <FullPanel>
        <Panel title="Selected Meter Info" primaryHeader />
        <PanelContent>
          <SubPanel>
            <SubPanelRow>
              <PanelRowDescriptor>
                <Text fontSize="12px">UOM</Text>
              </PanelRowDescriptor>
              <PanelRowDisplay>
                <Text fontSize="12px">
                  {data.uom !== null
                    ? API_FIELD_MAPPINGS.METER.uom[data.uom].displayText
                    : 'N/A'}
                </Text>
              </PanelRowDisplay>
            </SubPanelRow>

            <SubPanelRow>
              <PanelRowDescriptor>
                <Text fontSize="12px">Value</Text>
              </PanelRowDescriptor>
              <PanelRowDisplay>
                <Text fontSize="12px">
                  {data.value !== null
                    ? `${(data.value * Math.pow(10, data.ptm)).toFixed(2)}${
                        API_FIELD_MAPPINGS.METER.uom[data.uom].displayUnit
                      }`
                    : ''}
                </Text>
              </PanelRowDisplay>
            </SubPanelRow>

            <SubPanelRow>
              <PanelRowDescriptor>
                <Text fontSize="12px">Phase</Text>
              </PanelRowDescriptor>
              <PanelRowDisplay>
                <Text fontSize="12px">
                  {data.phase !== null
                    ? API_FIELD_MAPPINGS.METER.phase[data.phase].displayText
                    : ''}
                </Text>
              </PanelRowDisplay>
            </SubPanelRow>

            <SubPanelRow>
              <PanelRowDescriptor>
                <Text fontSize="12px">Qualifier</Text>
              </PanelRowDescriptor>
              <PanelRowDisplay>
                <Text fontSize="12px">
                  {data.qualifier !== null
                    ? API_FIELD_MAPPINGS.METER.qualifier[data.qualifier]
                        .displayText
                    : 'N/A'}
                </Text>
              </PanelRowDisplay>
            </SubPanelRow>

            <SubPanelRow>
              <PanelRowDescriptor>
                <Text fontSize="12px">Timestamp</Text>
              </PanelRowDescriptor>
              <PanelRowDisplay>
                <Text fontSize="12px">
                  {moment.unix(data.timestamp).format(DATE_FORMAT)}
                </Text>
              </PanelRowDisplay>
            </SubPanelRow>
          </SubPanel>
        </PanelContent>
        <PanelButtonRow>
          <BlueBorderButton onClick={() => dispatch(revertSidePanel())}>
            Back
          </BlueBorderButton>
        </PanelButtonRow>
      </FullPanel>
    );
  } else {
    return <></>;
  }
};

export default MeterPanel;
